<template>
  <nav
    class="kb-print-hide lg:hidden flex-shrink-0 grid grid-cols-5 border-t border-kb-line bg-kb-pane pb-[env(safe-area-inset-bottom,0px)]"
    aria-label="Main"
  >
    <NuxtLink
      v-for="tab in tabs"
      :key="tab.to"
      :to="tab.to"
      class="kb-tab"
      :class="isActive(tab.to) ? 'is-active' : ''"
      :aria-current="isActive(tab.to) ? 'page' : undefined"
    >
      <i :class="['pi', tab.icon]" />
      <span>{{ tab.label }}</span>
    </NuxtLink>
    <a
      v-styleclass="{
        selector: '#app-sidebar-9',
        enterFromClass: 'hidden',
        enterActiveClass: 'animate-fadeinleft',
        leaveToClass: 'hidden',
        leaveActiveClass: 'animate-fadeoutleft',
        hideOnOutsideClick: true,
      }"
      class="kb-tab"
      role="button"
      aria-label="More pages"
    >
      <span class="relative">
        <i class="pi pi-bars" />
        <span
          v-if="unreadCount > 0"
          class="absolute -top-0.5 -right-1 w-2 h-2 rounded-full bg-kb-gold"
          aria-label="Unread notifications"
        />
      </span>
      <span>More</span>
    </a>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNotifications } from '~/composables/useNotifications'

const props = defineProps<{
  hasSubkrewe?: boolean
}>()

const route = useRoute()
const { unreadCount } = useNotifications()

const tabs = computed(() => [
  { label: 'Home', icon: 'pi-home', to: '/' },
  { label: props.hasSubkrewe ? 'SubKrewe' : 'Find', icon: props.hasSubkrewe ? 'pi-flag' : 'pi-search', to: '/subkrewe' },
  { label: 'Code', icon: 'pi-qrcode', to: '/checkin/qrcode' },
  { label: 'Orders', icon: 'pi-receipt', to: '/purchases' },
])

const isActive = (to: string) => route.path === to
</script>

<style scoped>
.kb-tab {
  display: grid;
  justify-items: center;
  gap: 3px;
  padding: 9px 0 6px;
  font: 10.5px var(--kb-font-mono);
  color: var(--kb-dim);
  text-decoration: none;
  cursor: pointer;
}

.kb-tab .pi {
  font-size: 18px;
}

.kb-tab.is-active {
  color: var(--kb-accent);
}
</style>
